module.exports = __webpack_public_path__ + "static/img/oracle-genai-badge.6381620.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/awards/oracle-genai-badge.png
// module id = x9Aq
// module chunks = 1